module.exports = __webpack_public_path__ + "static/media/img06.e6adf5d8.png";